import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import { Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem } from "@blueprintjs/core";
import _ from "lodash";
import { List, Map } from "immutable";
import moment from 'moment';
import Auth from '../../lib/auth';

// Components
import VirtualizedTable from "../../components/common/virtualized-table";
import ProjectListPrint from "../../components/common/ProjectListPrint";
import Select from "../../components/common/virtualized-select";
import Loading from '../../components/common/Loading';

// Actions
import { getYears, cleanYears } from '../../actions/years';
import { getProjects, changeProjectStatus, cleanProjects } from "../../actions/projects";
import {downloadPdf} from "../../actions/content";

const queryOptions = {
    projection: 'project_code name description order statistics status document_date key',
    calculateStatistics: 'projects',
    calcIsAsync: true,
    populateRefs: [{
        field: 'order',
        projection: 'order_code'
    }],
    deleteVirtuals: true
};

class ProjectsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            projectsFilter: '',
            selectedYear: Auth.getSelectedYear(),
            projectsIsFetching: false
        };
    }
    componentDidMount() {
        this.props.getYears();
        this.updateQueryOptions(this.state.selectedYear);
        this.props.getProjects(queryOptions);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedYear !== prevState.selectedYear) {
            this.updateQueryOptions(this.state.selectedYear);
            this.props.getProjects(queryOptions);
        }
    }
    componentWillUnmount() {
        this.props.cleanProjects();
        this.props.cleanYears();
    }

    updateQueryOptions = (selectedYear) => {
        queryOptions.filters = {
            createdAt: {
                $gte: new Date(moment(selectedYear, "YYYY").startOf("year")),
                $lt: new Date(moment(selectedYear, "YYYY").endOf("year"))
            }
        };
    };

    onChangeYear = (year) => {
        this.setState({
            selectedYear: year
        });

        Auth.setSelectedYear(year);
    };

    // Print PDF
    printPdf = () => {
        const htmlHeader = ReactDOMServer.renderToStaticMarkup(<div></div>);
        const generateStaticMarkup = ReactDOMServer.renderToStaticMarkup(
            <ProjectListPrint
                projectList={this.props.projects.filter(project => project.get('status') === 'active')}
            />
        );
        const htmlFooter = ReactDOMServer.renderToStaticMarkup(<div></div>);

        this.props.downloadPdf(generateStaticMarkup, {
            title: 'Proyectos-Activos.pdf',
            printBackground: true,
            displayHeaderFooter: true,
            headerTemplate: htmlHeader,
            footerTemplate: htmlFooter,
            margin: {
                top: '50px',
                right: '50px',
                left: '50px',
                bottom: '150px'
            }
        });
    };

    render() {
        const yearOptions = this.props.years || List([Map({ year: moment().year })]);

        let tableData = this.props.projects;
        const projectsIsFetching = this.props.projectsIsFetching;

        // Filters Zone
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.projects.size }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ projectsFilter: '' }) } ><strong>Total</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.projects.count(project => project.get('status') === 'active') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ projectsFilter: 'active' }) } >Activos</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.projects.count(project => project.get('status') === 'inactive') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ projectsFilter: 'inactive' }) } >Inactivos</span>
                </div>
                <div className="col-auto ml-auto">
                    <button className="btn btn-custom" onClick={this.printPdf} ><Icon icon="print"/>Imprimir lista activos</button>
                </div>
            </div>
        );
        switch (this.state.projectsFilter) {
            case 'active':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.projects.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ projectsFilter: '' }) } >Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary"><strong>{ this.props.projects.count(project => project.get('status') === 'active') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ projectsFilter: 'active' }) } ><strong>Activos</strong></span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.projects.count(project => project.get('status') === 'inactive') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ projectsFilter: 'inactive' }) } >Inactivos</span>
                        </div>
                        <div className="col-auto ml-auto">
                            <button className="btn btn-custom" onClick={this.printPdf} ><Icon icon="print"/>Imprimir lista activos</button>
                        </div>
                    </div>
                );
                tableData = this.props.projects.filter( project => project.get('status') === 'active' );
                break;
            case 'inactive':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.projects.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ projectsFilter: '' }) } >Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.projects.count(project => project.get('status') === 'active') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ projectsFilter: 'active' }) } >Activos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger"><strong>{ this.props.projects.count(project => project.get('status') === 'inactive') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ projectsFilter: 'inactive' }) } ><strong>Inactivos</strong></span>
                        </div>
                        <div className="col-auto ml-auto">
                            <button className="btn btn-custom" onClick={this.printPdf} ><Icon icon="print"/>Imprimir lista activos</button>
                        </div>
                    </div>
                );
                tableData = this.props.projects.filter( project => project.get('status') === 'inactive' );
                break;
            default :
                break;
        }

        // Projects Table
        let tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            project_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'project_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/proyectos/' + value[0] }>{ value[1] }</Link>
                }
            },
            name: {
                title: "Nombre",
                columnType: 'function',
                dataField: ['_id', 'name'],
                width: 200,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/proyectos/' + value[0] }>{ value[1] }</Link>
                }
            },
            description: {
                title: "Descripción",
                columnType: 'text',
                dataField: 'description',
                width: 150,
                style: {},
                sortable: false,
                filterable: true,
            },
            key: {
                title: "Tecla",
                columnType: 'text',
                dataField: 'key',
                width: 50,
                style: {},
                sortable: false,
                filterable: true
            },
            order: {
                title: "Pedido",
                columnType: 'text',
                dataField: 'order',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            target_margin: {
                title: "Margen objetivo (%)",
                columnType: 'number',
                dataField: 'statistics.target_margin',
                width: 150,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                format: '0,0.00 %'
            },
            current_margin: {
                title: "Margen actual (%)",
                columnType: 'number',
                dataField: 'statistics.current_margin',
                width: 150,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                format: '0,0.00 %'
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let data = value === 'active'
                        ? { badgeColor: 'primary', value: 'activo' }
                        : value === 'inactive'
                            ? { badgeColor: 'danger', value: 'inactivo' }
                            : { badgeColor: 'info', value };

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {_.capitalize(data.value)}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'status'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/proyectos/' + value[0])} />
                            { value[1] === 'active'
                                ? <MenuItem onClick={ () => this.props.changeProjectStatus(value[0], 'inactive', queryOptions) } icon="eye-off" text="Desactivar" />
                                : value[1] === 'inactive'
                                    ? <MenuItem onClick={ () => this.props.changeProjectStatus(value[0], 'active', queryOptions) } icon="eye-off" text="Activar" />
                                    : null
                            }
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item active">
                                <strong>Proyectos</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => this.props.history.push('/proyectos/nuevo') } > <Icon icon="insert"/>Proyecto</button>
                        </div>
                        <div className="title-action">
                            <Select
                                style={{ width: 75, marginLeft: 20 }}
                                options={yearOptions.toJS()}
                                value={this.state.selectedYear}
                                labelKey='year'
                                valueKey='year'
                                matchProp='year'
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(selectedValue) => { if (selectedValue) this.onChangeYear(selectedValue.year) }}
                            />
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    { statsZone }
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    {projectsIsFetching ? (
                                        <Loading show={projectsIsFetching} />
                                    ) : (
                                        <VirtualizedTable
                                            tableSettings={tableSettings}
                                            tableColumns={tableColumns}
                                            tableData={tableData}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const yearsReducer = state.years;
    const projectsReducer = state.projects;

    // Years
    let years = yearsReducer.get('payload') || List([]);

    if (!(years instanceof List)) {
        years = List([])
    }

    // Projects
    let projects = projectsReducer.get('payload') || List([]);
    const projectsIsFetching = projectsReducer.get('isFetching');
    if (!(projects instanceof List)) projects = List([]);
    if (projects.size > 0) {
        projects = projects.map(project => {
            return project.set('statistics', project.get('statistics')
                .set('target_margin', project.getIn(['statistics', 'target_margin']) / 100)
                .set('current_margin', project.getIn(['statistics', 'current_margin']) / 100))
        });
    }

    return {
        years,
        projects,
        projectsIsFetching
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getYears: () => dispatch(getYears()),
        getProjects: (query) => dispatch(getProjects(query)),
        changeProjectStatus: (projectId, status, options) => dispatch(changeProjectStatus(projectId, status, options)),
        downloadPdf: (htmlString, pdfOptions) => dispatch(downloadPdf(htmlString, pdfOptions)),
        cleanYears: () => dispatch(cleanYears()),
        cleanProjects: () => dispatch(cleanProjects())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsPage);


// WEBPACK FOOTER //
// ./src/containers/projects/ProjectsPage.js